import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { AuthApi } from '../api/client.js';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => {
    try { return JSON.parse(localStorage.getItem('auth')) || null; } catch { return null; }
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = useCallback(async (email, senha) => {
    setLoading(true); setError(null);
    try {
  const data = await AuthApi.login(email, senha);
      setAuth(data);
      localStorage.setItem('auth', JSON.stringify(data));
      return data;
    } catch (e) {
      setError(e?.response?.data?.message || 'Falha ao entrar');
      throw e;
    } finally { setLoading(false); }
  }, []);

  const logout = useCallback(() => {
    setAuth(null);
    localStorage.removeItem('auth');
    localStorage.removeItem('defaultColaboradorId');
  }, []);

  useEffect(() => {
    if (!auth?.accessToken) return undefined;

    const verifySession = async () => {
      try {
        await AuthApi.me();
      } catch (e) {
        if (e?.response?.status === 401) {
          logout();
          if (!location.pathname.startsWith('/login')) location.href = '/login';
        }
      }
    };

    verifySession();
    const intervalId = setInterval(verifySession, 180000);
    return () => clearInterval(intervalId);
  }, [auth?.accessToken, logout]);

  const perfil = auth?.usuario?.perfil;

  return (
    <AuthContext.Provider value={{ auth, perfil, login, logout, loading, error }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
